import { createSelector } from "@ngrx/store";
import { selectDataSlice } from "./data-slice.selector";

export const selectWoundCareTree = createSelector(selectDataSlice, (state) => state.woundCareTree);

export const selectAllWoundCareTreeItems = createSelector(selectWoundCareTree, (state) => state.items);

export const selectWoundCareTreeItemById = (id: string) =>
	createSelector(selectAllWoundCareTreeItems, (items) => items && items[id]);

export const selectAllWoundCareProtocols = createSelector(selectWoundCareTree, (state) => state.protocols);

export const selectWoundCareProtocolById = (id: string) =>
	createSelector(selectAllWoundCareProtocols, (protocols) => protocols && protocols[id]);
